import { render, staticRenderFns } from "./valuationCompany.vue?vue&type=template&id=6f204884"
import script from "./valuationCompany.vue?vue&type=script&lang=js"
export * from "./valuationCompany.vue?vue&type=script&lang=js"
import style0 from "./valuationCompany.vue?vue&type=style&index=0&id=6f204884&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports